import { enTranslations } from './translations.en';
import { arTranslations } from './translations.ar';
import { deTranslations } from './translations.de';
import { esTranslations } from './translations.es';
import { frTranslations } from './translations.fr';
import { itTranslations } from './translations.it';
import { ptTranslations } from './translations.pt';
import { zhCnTranslations } from './translations.zh-cn';

export const SUPPORTED_LANGUAGES = ['en', 'it', 'es', 'de', 'fr', 'pt', 'zh-CN', 'ar'] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];
export type TranslationDictionary = Record<string, string>;

export const TRANSLATIONS: Record<Language, TranslationDictionary> = {
  en: enTranslations,
  it: itTranslations,
  es: esTranslations,
  de: deTranslations,
  fr: frTranslations,
  pt: ptTranslations,
  'zh-CN': zhCnTranslations,
  ar: arTranslations
};
